import { render, staticRenderFns } from "./market-item.vue?vue&type=template&id=42f9b136&scoped=true"
import script from "./market-item.vue?vue&type=script&lang=js"
export * from "./market-item.vue?vue&type=script&lang=js"
import style0 from "./market-item.vue?vue&type=style&index=0&id=42f9b136&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42f9b136",
  null
  
)

export default component.exports